import {
  ApiChartAttribute,
  ApiDimension,
  ApiOperator,
} from "@incendium/api";

export interface ProductPerformanceFilters {
  category: string;
  brand: string;
}

export function buildProductPerformanceAttributes(
  filters: ProductPerformanceFilters,
): ApiChartAttribute[] {
  const attributes: ApiChartAttribute[] = [];

  if (filters.category) {
    attributes.push({
      key: ApiDimension.DIMENSION_PRODUCT_CATEGORY,
      operator: ApiOperator.EQUAL,
      value: filters.category,
    });
  }

  if (filters.brand) {
    attributes.push({
      key: ApiDimension.DIMENSION_PRODUCT_BRAND,
      operator: ApiOperator.EQUAL,
      value: filters.brand,
    });
  }

  return attributes;
}

export function buildProductTrendAttributes(
  chartAttributes: ApiChartAttribute[],
  productNames: string[],
): ApiChartAttribute[] {
  if (!productNames.length) {
    return chartAttributes;
  }

  return [
    ...chartAttributes,
    ...productNames.map((name) => ({
      key: ApiDimension.DIMENSION_PRODUCT_NAME,
      operator: ApiOperator.EQUAL,
      value: name,
    })),
  ];
}
